import { createContext, useContext, useState } from "react";

const UnitContext = createContext(null);

export function UnitProvider({ children }) {
  const [unit, setUnit] = useState(localStorage.getItem("gym_unit") || "lb");

  const toggleUnit = () => {
    const u = unit === "lb" ? "kg" : "lb";
    localStorage.setItem("gym_unit", u);
    setUnit(u);
  };

  const dw = (w) => {
    if (w == null) return w;
    return unit === "kg" ? Math.round(w * 0.453592 * 10) / 10 : Math.round(w * 10) / 10;
  };

  const toLb = (v) => (unit === "kg" ? Math.round((v / 0.453592) * 100) / 100 : v);

  return (
    <UnitContext.Provider value={{ unit, toggleUnit, dw, toLb }}>
      {children}
    </UnitContext.Provider>
  );
}

export const useUnit = () => useContext(UnitContext);
